import { HotelSearch } from './HotelSearch';

export default HotelSearch;
